// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportNameEditor.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Report Name Editor component
 */
!(function() {
  var connect = require('share/enhancers/Izenda.Connect');
  var React = require('react');
  var observer = require('mobx-react').observer;
  var AppGlobal = require('Izenda.AppGlobal');

  var Validator = require('share/components/hoc/Izenda.Validator');
  var DropDown = require('share/components/controls/Izenda.DropDown');
  var actions = require('./Izenda.ReportNameEditorActions');
  var constants = require('logic/data/Izenda.ReportDesignerConstants');
  var Input = require('share/components/controls/Izenda.Input');
  var InputWithValidator = Validator()(Input);
  var EventsUtils = require('EventUtils');
  var notifyChange = EventsUtils.notifyChange;
  var localizer = require('share/localization/Izenda.Localizer');
  var classnames = require('classnames');
  var OverflowText = require('share/components/controls/Izenda.OverflowText');
  var { merge } = require('lodash/fp');

  var ReportDesignerTooltip = observer(function(props) {
    var otherSetting = AppGlobal.advancedSettings.other;
    var introductionText = otherSetting.showIntroductionTextValue ? otherSetting.introductionTextValue : '';
    return this.props.showTooltip ? (
      <div className='tool-tip u_paddingAll u_marginBottom'>
        <OverflowText tooltip={introductionText}>
          <i className='icon-lightbulb' />
          {introductionText}
        </OverflowText>
      </div>
    ) : null;
  });

  var ReportPreviewRecord = observer(function(props) {
    var isPreviewRecord = this.props.isPreviewRecord;
    var previewRecord = this.props.previewRecord;
    var updatePreviewRecord = this.props.updatePreviewRecord;

    return isPreviewRecord ? (
      <div className='col-md-4'>
        <div className='u_table u_fullWidth u_paddingInner u-bgWhite preview-records'>
          <span className='u_tableCell control-label u_alignMiddle'>
            {localizer.getText('REPORTDESIGNER_LABEL_PREVIEW_RECORDS')}
          </span>
          <div className='u_tableCell u_fullWidth'>
            <DropDown
              options={constants.PREVIEW_RECORD}
              value={previewRecord}
              labelField='label'
              valueField='value'
              onChange={notifyChange(updatePreviewRecord, EventsUtils.DROPDOWN)}
            />
          </div>
        </div>
      </div>
    ) : null;
  });

  var GlobalReportCheckbox = observer(function(props) {
    var store = props.store;
    var status = store.statusGlobalCheckbox;
    var className = classnames(props.className, 'global-report');
    return status.visible ? (
      <div className={className}>
        <label className='u_table u_fullWidth'>
          <Input
            type='checkbox'
            className='global-checkbox'
            disabled={status.disabled}
            checked={status.checked}
            onChange={notifyChange(props.onChangeGlobalValue, EventsUtils.CHECKBOX)}
          />
          {localizer.getText('COMMON_LABEL_GLOBAL_REPORT')}
        </label>
      </div>
    ) : null;
  });
  GlobalReportCheckbox.displayName = 'GlobalReportCheckbox';

  var ReportNameEditor = React.createClass({
    propTypes: {
      store: React.PropTypes.object.isRequired,
      name: React.PropTypes.string.isRequired,
      isPreviewRecord: React.PropTypes.bool.isRequired,
      showTooltip: React.PropTypes.bool.isRequired
    },

    /**
     * Component will receive props
     */
    componentWillReceiveProps: function(nextProps) {
      if (nextProps.name !== this.props.name) {
        nextProps.updateReportName(nextProps.name);
      }
    },

    renderEditMode: function() {
      var props = this.props;
      var store = props.store;
      var reportName = props.reportName;
      var reportType = store.model.reportType;
      var onSave = props.onSave;
      var onCancel = props.onCancel;
      var onKeyPress = props.onKeyPress;
      var onBlur = props.onBlur;
      var updateReportName = props.updateReportName;
      var localization = props.localization;
      var reportNameValidation = merge(
        store.isNewReport || reportType === constants.REPORT_TYPE_ENUM.REPORT
          ? constants.CONSTRAINTS.REPORT_NAME
          : constants.CONSTRAINTS.TEMPLATE_NAME,
        {
          action: function() {
            return store.validate.bind(store, reportName);
          }
        }
      );

      // Use onMouseDown event instead of onClick event to pass onBlur of report name.
      return (
        <div className='title-edit'>
          <div className='input-group'>
            <InputWithValidator
              value={reportName}
              onChange={notifyChange(updateReportName, EventsUtils.INPUT)}
              onBlur={onSave}
              onKeyPress={onKeyPress}
              field='reportName'
              validations={reportNameValidation}
              className='form-control'
              autoFocus
            />
            <span className='input-group-btn'>
              <button
                className='btn btn-default'
                onMouseDown={onSave}
                title={localization.getText('COMMON_TOOLTIP_UPDATE_CHANGE')}
              >
                <span className='icon-ok success-color' />
              </button>
              <button
                className='btn btn-default'
                onMouseDown={onCancel}
                title={localization.getText('COMMON_TOOLTIP_CANCEL_CHANGE')}
              >
                <span className='icon-cancel' />
              </button>
            </span>
          </div>
        </div>
      );
    },

    renderNormalMode: function() {
      var reportName = this.props.name;
      var onEdit = this.props.onEdit;
      var localization = this.props.localization;
      return (
        <div className='u_flexHorizontal'>
          <div className='u_textTruncate'>
            <span className='text-bold'>{reportName}</span>
          </div>
          <div className='u_fullInlineBlock'>
            <i className='icon-pencil-new' title={localization.getText('COMMON_TOOLTIP_RENAME')} onClick={onEdit} />
          </div>
        </div>
      );
    },

    renderReportNameEditor: function() {
      var editMode = this.props.editMode;
      var isGlobalReportCheckbox = this.props.store.statusGlobalCheckbox.visible;
      var classes;
      if (this.props.isPreviewRecord) {
        classes = classnames({
          'col-md-5': isGlobalReportCheckbox,
          'col-md-8': !isGlobalReportCheckbox
        });
      } else {
        classes = classnames({
          'col-md-9': isGlobalReportCheckbox,
          'col-md-12': !isGlobalReportCheckbox
        });
      }

      return (
        <div className={'report-name ' + classes}>
          <div>{editMode ? this.renderEditMode() : this.renderNormalMode()}</div>
        </div>
      );
    },

    render: function() {
      var props = this.props;
      var reportDesignerModel = props.store.model;
      var showTooltip = props.showTooltip;
      var isPreviewRecord = props.isPreviewRecord;
      var previewRecord = reportDesignerModel.previewRecord;

      var updatePreviewRecord = function(value) {
        reportDesignerModel.updatePreviewRecord(value);
        props.onChangePreviewRecord && props.onChangePreviewRecord(props);
      };

      return (
        <div className='izenda-ReportDesignerToolBar'>
          <div className='row izenda-ReportHeader'>
            {this.renderReportNameEditor()}
            <GlobalReportCheckbox
              store={props.store}
              className='col-md-3'
              onChangeGlobalValue={props.onChangeGlobalValue}
            />
            <ReportPreviewRecord
              isPreviewRecord={isPreviewRecord}
              previewRecord={previewRecord}
              updatePreviewRecord={updatePreviewRecord}
            />
          </div>

          <ReportDesignerTooltip showTooltip={showTooltip} />
        </div>
      );
    }
  });

  module.exports = connect(actions)(ReportNameEditor);
})();



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Izenda.ReportNameEditor.jsx